import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import BilingAddresspage from '../Components/BillingAddresspage/BilingAddresspage';


const BillingAddress = () => {


    const routePath = useLocation();
    const onTop = () => {
      window.scrollTo(0, 0);
    }
    useEffect(() => {
      onTop()
    }, [routePath]);
    
    
  return (
    <div>
     <BilingAddresspage/>
    </div>
  )
}

export default BillingAddress
